import React, { useEffect } from "react";
import { useRouter } from "next/router";
import DashboardHeader from "./Header";
import { IDashboardLayout } from "@/types/ui.types";
import cls from "@/styles/dashboard/layout/Layout.module.scss";
import "react-toastify/dist/ReactToastify.css";
import { sendGTMEvent } from "@next/third-parties/google";
import useMouseLeave from "@/hooks/common/useMouseOut";
import { usePricingExitDiscountPopupState } from "../pricing/data/usePricingExitDiscountPopup.state";
import { When } from "@/components/common/When";
import PricingPopup from "../pricing/PricingPopup";
import { initGtmTriggerGroups } from "@/gtm/trigger-groups";
import { gtm } from "@/gtm/events";
const DashboardLayout = ({
  children,
  show,
  button,
  dashboard
}: IDashboardLayout) => {
  const router = useRouter();
  useEffect(() => {
    sendGTMEvent({
      event: gtm.dashboard.visited
    });
    initGtmTriggerGroups();
  }, []);
  const {
    isShow,
    setIsShow,
    showDiscountPopUp,
    hasSeen
  } = usePricingExitDiscountPopupState();
  const isMouseLeaved = useMouseLeave();

  // showDiscountPopUp => if backend allowed to show the discount popup
  // hasSeen => if user has seen the discount popup
  // isMouseLeaved => if user leaved the mouse from the window
  const isDiscount = showDiscountPopUp && !hasSeen && isMouseLeaved;
  useEffect(() => {
    // isDiscount => if all the above conditions are true 
    if (isDiscount) setIsShow(true);
    document.body.style.overflow = isShow ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isDiscount, isShow]);
  return <div className={cls.Wrapper} data-sentry-component="DashboardLayout" data-sentry-source-file="DashboardLayout.tsx">
      {router.pathname !== "/dashboard" && <DashboardHeader showProfile={show} button={button} dashboard={dashboard} />}
      {children}

      <When condition={isShow && !hasSeen} data-sentry-element="When" data-sentry-source-file="DashboardLayout.tsx"> <PricingPopup data-sentry-element="PricingPopup" data-sentry-source-file="DashboardLayout.tsx" /></When>
    </div>;
};
export default DashboardLayout;